export const toMergeField = [
  'segment_id',
  'category',
  'poa_category_id',
  'sub_category',
  'forms_to_be_signed',
  'risk_level',
  'internal_approval_requirement',
  'internal_approval',
  'principal',
  'agent',
  'remarks',
]
